import React from "react";

//Component===============================
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import TextField from '@material-ui/core/TextField';

import Button from '@material-ui/core/Button';


import ConfigHost from "ConfigHost";
import randomCharacter from "randomCharacter";

//Style===============================
import withStyles from "@material-ui/core/styles/withStyles";
// import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";

var W3CWebSocket = require('websocket').w3cwebsocket;
var client_token = randomCharacter.generate(10,true);
var client = null;

const styles = theme => ({
    container2: {
        padding: 16,
        display: 'flex',
        flexWrap: 'wrap',
    },
    container: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    textField: {
      marginLeft: theme.spacing.unit,
      marginRight: theme.spacing.unit,
      width:"100%"
    },
    dense: {
      marginTop: 16,
    },
    menu: {
      width: 200,
    },
  });
class ChatPage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
          textValue:""
        }
      }
    componentDidMount(){
       this.connectWebsocket();
    }
    connectWebsocket = ()=>{
        client = new W3CWebSocket(ConfigHost.HOST_WS, "gtrealtimedashboard");
        console.log("Client Token : " + client_token);
        client.onerror = ()=> {
            console.log('Connection Error');
        };
         
        client.onopen = ()=> {
            console.log('WebSocket Client Connected');
        };
         
        client.onclose = ()=> {
            console.log('Client Closed. Waiting 3 sec for reconnecting.');
            setTimeout(()=>{
                console.log('Client reconnecting...');
                this.connectWebsocket();
            },3000);
        };
         
        // client.onmessage = (e)=> {
        //     if (typeof e.data === 'string') {
        //         const res = JSON.parse(e.data);
        //         if(res.datas.token != client_token){
        //             console.log("Received: '" + res.message + "'");
        //         }
        //     }
        // };
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    sendMessage = ()=>{
        console.log("sendMessage : "+this.state.textValue);
        const msgData = {
            code:"call",
            token: client_token,
            message : this.state.textValue
        }
        client.send(JSON.stringify(msgData));
        this.setState({textValue:''})
    }
    render() {
        const { classes } = this.props;
        return (
            <div className={classes.container2 + " fullWidth"}>
                <Card>
                    <CardBody>
                        <GridContainer justify="center">
                            <GridItem xs={12} sm={12} md={11}>
                                Test Websocket Client
                            </GridItem>
                            <GridItem xs={12} sm={12} md={11}>
                                <TextField
                                    id="outlined-name"
                                    label="Message"
                                    className={classes.textField}
                                    value={this.state.textValue}
                                    onChange={this.handleChange('textValue')}
                                    margin="normal"
                                    variant="outlined"
                                />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={11}>
                                <Button onClick={(e)=>this.sendMessage()} variant="outlined" color="primary" className={classes.button}>
                                    Send
                                </Button>
                            </GridItem>
                        </GridContainer>
                    </CardBody>
                </Card>
            </div>
        );
    }
}

export default withStyles(styles)(ChatPage);
